import React from 'react';
import { FormattedMessage } from 'react-intl';
import { sortLegsByDate } from 'utils/sortLegsByDate';
import PropTypes from 'prop-types';
import { StyledLegContainer } from '../AddOns.styles';
import ExtrasJourneyInfo from '../../../Extras/ExtrasTrain/ExtrasJourneyInfo';
import AddOnProduct from '../AddOnProduct';
import journeyPropType from '../../../../../constants/propTypes/journey';

const AddOnLeg = ({ journey, direction }) => {
  const legs = journey.filter((i) => !i.cancelled).sort(sortLegsByDate);

  return (
    <>
      <h2>
        <FormattedMessage id={`addAssistance.journey.${direction}`} />
      </h2>
      {legs.length > 0 ? (
        legs.map((leg) => (
          <StyledLegContainer key={`${leg.id}`}>
            <ExtrasJourneyInfo direction={leg} />
            <AddOnProduct direction={leg} />
          </StyledLegContainer>
        ))
      ) : (
        <FormattedMessage id="assistance.noInboundMessage" />
      )}
    </>
  );
};

AddOnLeg.propTypes = {
  journey: journeyPropType,
  direction: PropTypes.string
};

export default AddOnLeg;
